module.exports = __webpack_public_path__ + "static/media/DubaiW23-Regular.b8876272.eot";